module App.Interfaces
{
    export interface IUtmParam
    {
        key: string
        value: string
    }
}